import { from } from 'rxjs';
import { Acabado } from './acabado.model';
import { CaracteristicaMaterial } from './caracteristica-material.model';
import { ColorMaterial } from './color-material.model';
import { Continente } from './continente.model';
import { Disponibilidad } from './disponibilidad.model';
import { Espesor } from './espesor.model';
import { Material } from './material.model';
import { RangoPrecio } from './rango-precio.model';
import { TipoMaterial } from './tipo-material.model';
import { UsoMaterial } from './uso-material.model';

export * from './tree-menu.model';
export * from './acabado.model';
export * from './caracteristica-material.model';
export * from './color-material.model';
export * from './continente.model';
export * from './material.model';
export * from './pais.model';
export * from './stock.model';
export * from './tipo-material.model';
export * from './uso-material.model';
export * from './filter.model';
export * from './espesor.model';
export * from './disponibilidad.model';
export * from './rango-precio.model';
export * from './bookmatch.model';
export * from './unidad-medida.model';

export interface Maestros {
  tipoMaterial?: TipoMaterial[];
  acabado?: Acabado[];
  usoMaterial?: UsoMaterial[];
  continente?: Continente[];
  colorMaterial?: ColorMaterial[];
  espesor?: Espesor[];
  disponibilidad?: Disponibilidad[];
  rangoPrecio?: RangoPrecio[];
  materiales?: Material[];
  caracteristicasMaterial?: CaracteristicaMaterial[];
}
